import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";


const ProductsManagement = () => {
    const [query, setQuery] = useState("");
    const [products, setProducts] = useState([]);

    const [showDeleteItem, setShowDeleteItem] = useState(false);
    const [idSelectRemove, setIdSelectRemove] = useState('');
    const [selectedProductRemove, setSelectedProductRemove] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [statusHandle, setStatusHandle] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);

    const { apiUrl } = useSelector(state => state.api);

    const getProducts = async () => {
        try {
            const response = await axios.get(`${apiUrl}/product`)
            const dataProducts = response.data
            setProducts(dataProducts)
        } catch (err) {
            console.error(err.message);
        }
    };
    useEffect(() => {
        // findInfo();
        getProducts();
    }, [apiUrl]);

    const handleSearch = async () => {
        const data = { query };
        try {
            if (!query) {
                getProducts();
            } else {
                const response = await axios.get(`${apiUrl}/dashboard/product/query`, {
                    params: data,
                    headers: { token: localStorage.getItem('token') }
                });
                //handle data place order from database
                const { getProduct } = response.data;
                setProducts(getProduct);
                setCurrentPage(1);
            }
        } catch (err) {
            console.error(err.message);
            console.log(err.response);
            // setStatusSearch(err.response.data)
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };



    // Remove item from database store
    const handleRemoveProduct = (product_id) => {
        console.log(product_id);
        const findProduct = products.filter(item => product_id.includes(item.product_id));
        setSelectedProductRemove(findProduct)
        setShowDeleteItem(true);
        setIdSelectRemove(product_id);
    }

    // Remove item from database store
    const handleRemoveItem = async (idSelectRemove) => {
        // idSelectRemove is an index in cart
        try {
            if (idSelectRemove) {
                console.log("idSelectRemove", idSelectRemove);
                const response = await axios.delete(`${apiUrl}/dashboard/deleteproduct`, {
                    data: { product_id: idSelectRemove },
                    headers: { token: localStorage.getItem('token') }
                });
                setStatusHandle(response.data);

                const responseGetProductAgain = await axios.get(`${apiUrl}/product`)
                console.log(responseGetProductAgain);
                const dataProducts = responseGetProductAgain.data;
                setProducts(dataProducts);
                setTimeout(() => {
                    setStatusHandle("");
                    setShowDeleteItem(false);
                }, 1500);
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    //handle delete Checkbox checked
    const handleCheckboxChange = (e, product_id) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, product_id]);
        } else {
            setSelectedItems(selectedItems.filter(id => id !== product_id));
        }
    }


    //create index list orders
    const productsPerPage = 10;//number of product on page
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="col-md-10 bg-light p-2 ">
            <div className="row d-flex justify-content-center">

                <div class="col-md-10 text-center">

                    <div className="input-group mb-3 ">
                        <input
                            type="text" className="form-control" aria-label="Search" aria-describedby="basic-addon2"
                            placeholder="You are can search by name product or ID order"
                            value={query}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <button
                            className="btn btn-outline-secondary" type="button" id="search-button"
                            onClick={handleSearch}
                        >
                            Search
                        </button>
                    </div>

                    <div className="input-group mb-3 ">
                        {(selectedItems.length > 1) && <div>
                            <button type="button" class="btn btn-warning button-edit  m-1"
                                // onClick={() => handleRemoveProduct(product.product_id)}
                                onClick={() => handleRemoveProduct(selectedItems)}
                            >Delete checked</button>
                        </div>}
                        <Link to={'/dashboard/addproduct'} >
                            <div>
                                <button type="button" class="btn btn-success button-edit m-1"
                                // onClick={() => handleRemoveProduct(product.product_id)}
                                >Add New Product</button>
                            </div>
                        </Link>
                    </div>
                    <div class="col-md-12 d-flex justify-content-center mt-4 mt-md-3">
                        <table className="table-product-dashboard">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentProducts.map((product, ind) => (
                                    <tr key={product.product_id}>
                                        <td >
                                            <input type="checkbox" class="checked" name={product.product_name}
                                                idcheck={product.product_id} style={{ margin: '5%' }}
                                                checked={selectedItems.includes(product.product_id)}
                                                onChange={(e) => handleCheckboxChange(e, product.product_id)}
                                            />
                                            <img src={apiUrl + "/" + product.product_img} alt={product.product_name} style={{ height: "80px", width: " 80px" }} />
                                        </td>
                                        <td>{product.product_name}</td>
                                        <td>${product.product_price.toLocaleString('en-US',
                                            { minimumFractionDigits: 2, maximumFractionDigits: 2, }).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                                        <td>{product.product_quantity}</td>

                                        {/* <td>
                                                <div class="btn-group" role="group" aria-label="Basic example"
                                                >
                                                    <button type="button" class="btn btn-light border border-dark"
                                                        onClick={() => handleDecrement(product.product_id)}
                                                    >-</button>
                                                    <button type="button" class="btn btn-light border border-dark">{product.count}</button>
                                                    <button type="button" class="btn btn-light border border-dark" onClick={() => handleIncrement(product.product_id)}>+</button>
                                                </div>
                                            </td> */}

                                        {/* <td>${(Math.round((product.count * product.product_price) * 100) / 100).toFixed(2)} <br />

                                            </td> */}

                                        <td>
                                            <Link to={`/editproduct/${product.product_id}`}>
                                                <button type="button" class="btn btn-light button-edit" style={{ size: 5 }}
                                                // onClick={() => handleRemoveProduct(product.product_id)}
                                                >Edit</button>
                                            </Link>
                                        </td>
                                        <td>
                                            <button type="button" class="btn btn-light btn-sm button-remove" style={{ size: 5 }}
                                                onClick={() => handleRemoveProduct([product.product_id])}
                                            >X</button>
                                        </td>
                                    </tr>

                                ))}
                            </tbody>

                        </table>

                    </div >


                    <div className="pagination-dashboard">
                        <nav aria-label="Page navigation">
                            <ul className="pagination">
                                {Array.from({ length: Math.ceil(products.length / productsPerPage) },
                                    (_, i) => i + 1).map((pageNumber) => (
                                        <li className={`page-item ${currentPage === pageNumber ? 'active' : ''}`} key={pageNumber}>
                                            <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                                                {pageNumber}
                                            </button>
                                        </li>
                                    )
                                    )}
                            </ul>
                        </nav>
                    </div>
                    {/* <!-- Modal --> */}
                    {(showDeleteItem === true) && (products.length > 0) && (
                        <div class="modal-container-dashboard">
                            <div class="my-modal-dashboard" >
                                <div class="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Remove Product</h5>
                                    <button type="button" class="btn-close" aria-label="Close" onClick={() => setShowDeleteItem(false)}></button>
                                </div>
                                <div className="modal-body-dashboard">

                                    {(selectedProductRemove.length <= 8) ? (<div class="text-start">
                                        <div class="row">
                                            {selectedProductRemove.map((item) => (
                                                <div class="col-12 col-md-6">
                                                    <img src={apiUrl + "/" + item.product_img} alt={item.product_name}
                                                        style={{ height: "50px", width: "50px", margin: '1%' }} />
                                                    {item.product_name.substring(0, 15) + "..."}
                                                    <br />
                                                </div>
                                            ))}
                                        </div>
                                    </div>) : (<div>
                                        {selectedProductRemove.map((item) => (
                                            <img src={apiUrl + "/" + item.product_img} alt={item.product_name}
                                                style={{ height: "50px", width: "50px", margin: '1%' }} />
                                        ))}
                                    </div>)
                                    }

                                    <br />

                                    Are you sure you want to remove this product from your store?

                                </div>
                                {statusHandle && <div class="statusChangePass">{statusHandle} </div>}
                                <div class="d-flex">
                                    <button type="button" class="btn btn-secondary w-50 mx-1" onClick={() => setShowDeleteItem(false)}>Close</button>
                                    <button type="button" className="btn btn-danger w-50 mx-1" onClick={() => handleRemoveItem(idSelectRemove)}>Remove</button>

                                </div>

                            </div>
                        </div>
                    )}
                    {/* <!-- Modal --> */}


                </div>


            </div>

        </div >



    )
}
export default ProductsManagement;